import React, { useEffect, useState } from "react";
import { apiClient } from "../../apiclient/apiclient";
import socket from "../../socket/socketClient";
import OrderCard from "../Delivery/Deliveries/OrderCard";
import { Eye } from "lucide-react";
import ThemedTable from "../../components/ThemedTable";
import { formatAnyDateToDDMMYYYY } from "../../utils/dateFormatter";
import PageHeader from "../../components/PageHeader";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
/* 🔹 SIMPLE MOBILE MODAL */
const Modal = ({ children, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, []);

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-end sm:items-center justify-center">
      <div
        className="
          bg-white w-full
          h-[90vh] sm:h-auto
          sm:max-w-3xl
          rounded-t-2xl sm:rounded-xl
          shadow-lg
          overflow-y-auto
          relative
        "
      >
        {/* Drag bar (mobile) */}
        <div className="sm:hidden flex justify-center py-2">
          <div className="w-10 h-1 bg-gray-300 rounded-full"></div>
        </div>

        {/* Close */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 text-lg"
        >
          ✕
        </button>

        <div className="p-4">{children}</div>
      </div>
    </div>
  );
};

const DeliveriesList = () => {
  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState("");
  const [viewModal, setViewModal] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  /* ================= LOAD ORDERS ================= */
const loadOrders = async () => {
  try {
    setLoading(true);

    const res = await apiClient.get("/orders?page=1&limit=100");

    const completedOrders = (res.data.data || []).filter(
      (o) => o.status === "completed"
    );

    setOrders(completedOrders);
  } catch (err) {
    console.error("Error loading deliveries", err);
  } finally {
    setLoading(false);
  }
};


  /* ================= INITIAL LOAD ================= */
  useEffect(() => {
    loadOrders();
  }, []);

  /* ================= SOCKET REALTIME ================= */
  useEffect(() => {
    const handleOrderUpdate = (updatedOrder) => {
      // update table list
      setOrders((prev) =>
        prev.map((o) => (o._id === updatedOrder._id ? updatedOrder : o))
      );

      // update open modal
      setViewModal((prev) =>
        prev && prev._id === updatedOrder._id ? updatedOrder : prev
      );
    };

    socket.on("order_updated", handleOrderUpdate);
    socket.on("order_status_updated", handleOrderUpdate);

    return () => {
      socket.off("order_updated", handleOrderUpdate);
      socket.off("order_status_updated", handleOrderUpdate);
    };
  }, []);

  /* ================= SEARCH ================= */
  const filteredOrders = orders.filter((o) => {
    const q = search.toLowerCase();
    return (
      !q ||
      o.orderId?.toLowerCase().includes(q) ||
      o.clientId?.name?.toLowerCase().includes(q)
    );
  });

  return (
  <div className="">
      {/* ✅ ORANGE FULL WIDTH HEADER */}
        <PageHeader
  title="My Deliveries"
  role="agent"
  variant="orange"   // same gradient you liked
  leftContent={
    <button onClick={() => navigate(-1)}>
      <ArrowLeft size={22} />
    </button>
  }
/>
<div className="p-3">
    <input
      className="border px-3 py-2 rounded-lg text-sm mb-3 w-full hover:border-amber-500 focus:outline-none focus:ring-1 focus:ring-amber-500 transition"
      placeholder="Search order or client"
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    />
</div>  
    {/* ================= CARDS ================= */}
   <div className="space-y-4 p-2">
  {loading ? (
    <Loader text="Loading deliveries..." />
  ) : filteredOrders.length === 0 ? (
    <div className="bg-white border rounded-lg p-4 text-center text-gray-500">
      No deliveries found
    </div>
  ) : (
    filteredOrders.map((order) => (

         <div
  key={order._id}
  className="bg-white rounded-2xl shadow-sm border border-gray-200 p-4 hover:shadow-md transition-all duration-200"
>
  {/* Top Section */}
  <div className="flex justify-between items-start">

    {/* Left Info */}
    <div>
      <h3 className="text-base font-semibold text-blue-900">
        {order.orderId}
      </h3>

      <p className="text-sm text-gray-700 capitalize">
        {order.clientId?.name}
      </p>

      <p className="text-xs text-gray-400 mt-1">
        {formatAnyDateToDDMMYYYY(order.createdAt)}
      </p>
    </div>

    {/* Status */}
    {/* <span
      className={`px-3 py-1 rounded-full text-xs font-semibold
        ${
          order.status === "completed"
            ? "bg-green-100 text-green-700"
            : order.status === "delivered"
            ? "bg-purple-100 text-purple-700"
            : order.status === "shipped"
            ? "bg-blue-100 text-blue-700"
            : "bg-yellow-100 text-yellow-700"
        }
      `}
    >
      {order.status.toUpperCase()}
    </span> */}
    <div className="flex justify-between items-center mt-4">


    <button
      onClick={() => setViewModal(order)}
      className="px-4 py-1.5 rounded-lg text-sm font-medium text-white
      bg-blue-900 
      shadow hover:shadow-md hover:bg-amber-500 transition-all"
    >
      View
    </button>

  </div>
  </div>

  {/* Bottom Row */}
  
</div>

        ))
      )}
    </div>

    {/* ================= MODAL ================= */}
    {viewModal && (
      <Modal onClose={() => setViewModal(null)}>
        <OrderCard
          order={viewModal}
          viewOnly={true}
          onClose={() => setViewModal(null)}
        />
      </Modal>
    )}
  </div>
);

};

export default DeliveriesList;
